/*
 * @Description: 公用接口
 * @Author: xyw
 * @Date: 2021-09-09 15:44:20
 * @LastEditTime: 2022-01-06 14:56:48
 * @LastEditors: xyw
 */

import Request from '@/utils/request'
//获取短信开关状态
export function selectSmsSwitch(params) {
  return Request.get('/selectSmsSwitch', { params })
}
//修改短信开关状态
export function updateSmsSwitch(data) {
  return Request.put('/updateSmsSwitch', data)
}
//发起支付
export function sendPay(data) {
  return Request.post('/pay/sendPay', data)
}
//申请退款
export function applyRefund(data) {
  return Request.post('/pay/applyRefund', data)
}
//下载邮寄材料
export function downloadMaterials(data) {
  return Request.post('/wordHandle/partner/downloadMaterials', data)
}

//查看手机号
export function saveRecord(data) {
  return Request.post('/phoneRecord/saveRecord', data)
}
